<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="C"
			:itemcode="(curWebsite.type == 5 || curWebsite.type == 6) ? 'T-TZJG' : 'A-TZJG'"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 0;">
					<div class="right_boxtitle">
						<span class="fl right_title" v-if="curWebsite.type != 5">投资机构</span>
						<span class="fl right_title" v-if="curWebsite.type == 5">投资动态</span>
						<div class="fl search-box nz-search-box" v-show="curWebsite.type != 5">
							<span class="searchtype">投资机构</span>
							<input type="text" placeholder="请输入投资机构名称" class="search-input" v-model="searchtext"
								@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div>
					<div>
						<div class="opport-screen-list1">
							<div class="spage-searchbox ">
								<!-- 投资版名字 创新企业融资 -->
								<dynamicNavTZ code="zyjgtz" v-if="curWebsite.type == 5" v-on:receive='receive'>
								</dynamicNavTZ>
								<dl class="opport-screen bdbe">
									<dt class="fl">主投阶段</dt>
									<dd class="fl">
										<span :class="stage == '' ? 'a-screen current' : 'a-screen'"
											@click="investClick('stage', '')">全部</span>
										<span :class="stage == item.tagCode ? 'a-screen current' : 'a-screen'" :key="index"
											v-for="(item, index) in stagelist" v-if="item.tagName != '衰退期'"
											@click="investClick('stage', item.tagCode)">{{ item.tagName }}</span>
										<video-teaching :type="1"></video-teaching>
									</dd>
								</dl>
								<dl class="opport-screen bdbe">
									<dt class="fl">机构类型</dt>
									<dd class="fl">
										<span :class="type == '' ? 'a-screen current' : 'a-screen'"
											@click="investClick('type', '')">全部</span>
										<span :class="type == item.tagCode ? 'a-screen current' : 'a-screen'" :key="index"
											v-for="(item, index) in typelist"
											v-show="item.tagName != '其他' && item.tagName != '家族办公室' && item.tagName != '对冲基金' && item.tagName != '孵化器'"
											@click="investClick('type', item.tagCode) ">{{ item.tagName }}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe">
									<dt class="fl">机构知名度</dt>
									<dd class="fl">
										<span :class="popular == '' ? 'a-screen current' : 'a-screen'"
											@click="investClick('popular','')">全部</span>
										<span :class="popular == item.tagCode ? 'a-screen current' : 'a-screen'"
											:key="index" v-for="(item, index) in popularlist"
											@click="investClick('popular', item.tagCode)">{{ item.tagName }}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe">
									<dt class="fl">省份地区</dt>
									<dd class="fl">
										<span :class="provinceid == 0 ? 'current a-screen' : 'a-screen'"
											@click="provincechoose(0, 'all'); userdata.provinceText = '全国地区'">全国地区</span>
										<span :key="index" v-for="(item, index) in provincedata"
											@click="provincechoose(item.areaId, index); userdata.provinceText = item.areaName"
											:class="item.areaId == provinceid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
										<span class="fr pt display-inlineblock">
											<vedioTips :type="4"></vedioTips>
										</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="citydata.length != 0">
									<dt class="fl">城市地区</dt>
									<dd class="fl">
										<span :class="cityid == 0 ? 'current a-screen' : 'a-screen'"
											@click="choosecity(0, 'all'); userdata.cityText = ''">全部</span>
										<span :key="index" v-for="(item, index) in citydata"
											@click="choosecity(item.areaId, index); cityid = item.areaId; userdata.cityText = item.name"
											:data="item.areaId"
											:class="item.areaId == cityid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
									</dd>
								</dl>
								<!-- <dl class="opport-screen bdbe" v-show="countydata.length!=0">
							<dt class="fl">区县地区</dt>
							<dd class="fl">
								<span :class="countyid == 0?'current a-screen':'a-screen'"
									@click="choosecounty(0);userdata.countyText=''">全部</span>
								<span  :key="index"  v-for="(item,index) in countydata"
									@click="choosecounty(item.areaId);countyid=item.areaId;userdata.countyText=item.name"
									:data="item.areaId"
									:class=" item.areaId == countyid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
							</dd>
						</dl> -->
								<!-- <dl class="opport-screen bdbe">
									<dt class="fl">产业分类</dt>
									<dd class="fl screenop">
										<span @click="chooseNotion(1, 'a', { lable: '全部', value: 0, children: [] })"
											:class="notionCode == 0 ? 'a-screen current' : 'a-screen'">全部</span>
										<span :key="index" v-for="(item, index) in notionlist"
											v-show="item.label.indexOf('先进制造') > -1"
											:class="chooseNotionlist[0] == item.value ? 'a-screen current' : 'a-screen'"
											@click="chooseNotion(1, 'a', item)">{{ item.label }}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="notionlist1.length > 0">
									<dt class="fl titleop">一级产业</dt>
									<dd class="fl">
										<span @click="chooseNotion(2, 'all', fenkd)"
											:class="chooseNotionlist[1] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
										<span :key="index" v-for="(item, index) in notionlist1"
											:class="chooseNotionlist[1] == item.value ? 'a-screen current' : 'a-screen'"
											@click="chooseNotion(2, 'a', item)">{{ item.label }}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="notionlist2.length > 0">
									<dt class="fl titleop">二级细分</dt>
									<dd class="fl">
										<span @click="chooseNotion(3, 'all', fenkd)"
											:class="chooseNotionlist[2] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
										<span :key="index" v-for="(item, index) in notionlist2"
											:class="chooseNotionlist[2] == item.value ? 'a-screen current' : 'a-screen'"
											@click="chooseNotion(3, 'a', item)">{{ item.label }}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="notionlist3.length > 0">
									<dt class="fl titleop">三级细分</dt>
									<dd class="fl">
										<span @click="chooseNotion(4, 'all', fenkd)"
											:class="chooseNotionlist[3] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
										<span :key="index" v-for="(item, index) in notionlist3"
											:class="chooseNotionlist[3] == item.value ? 'a-screen current' : 'a-screen'"
											@click="chooseNotion(4, 'a', item)">{{ item.label }}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="notionlist4.length > 0">
									<dt class="fl titleop">四级细分</dt>
									<dd class="fl">
										<span @click="chooseNotion(5, 'all', fenkd)"
											:class="chooseNotionlist[4] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
										<span :key="index" v-for="(item, index) in notionlist4"
											:class="chooseNotionlist[4] == item.value ? 'a-screen current' : 'a-screen'"
											@click="chooseNotion(5, 'a', item)">{{ item.label }}</span>
									</dd>
								</dl> -->
								<!-- <dl class="opport-screen bdte" v-show="usernotionlist.length>0">
							<dt class="fl">已选产业</dt>
							<dd class="fl leftlian oh">
								<span class="span-screen fl" v-for="(item,index) in usernotionlist"
									@click="deletetag(index)">{{item.name}}<i @click="ckll(item.id)" class="concept_notionlist el-icon-close" ></i></span>
									<span class="fr concept_empty" @click="emty()">清空</span>
							</dd>
						</dl> -->
							</div>
						</div>

					</div>
				</div>
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{ total }}</span>条【 <span
								class="orangefont">{{ kwtextsearchtext }}</span>】相关结果</p>
					</div>
					<div class="enterprise_list_box" v-show="enterpristlist.length != 0">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-show="enterpristlist.length != 0">
							<tr>
								<th>企业名称 </th>
								<th>投资领域</th>
								<th>画像标签</th>
								<th>项目数</th>
								<!-- <th>进入下一轮项目数</th> -->
								<!-- <th>投资阶段</th> -->
								<th>机构类型</th>
								<th>地区</th>
								<th>管理规模 </th>
							</tr>
							<tr :key="i" v-for="(list, i) in enterpristlist">
								<td class="title" @click="detailrouterto(list.id, list.title)">{{ list.name }}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item, index) in list.notionlist"
										@click="tagrouter('/enterpriseTag', 6, 'notion', item.id, item.name)">{{ item.name }}</span>
									<i v-show="list.notion == ''">-</i>
								</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item, index) in list.taglist"
										@click="tagrouter('/enterpriseTag', 6, 'tag', item.id, item.name)">{{ item.name }}</span>
									<i v-show="list.tag == ''">-</i>
								</td>
								<td>{{ list.projectCount }}</td>
								<!-- <td>{{list.nextRound}}</td> -->
								<!-- <td>{{list.stage}}</td> -->
								<td>{{ list.type }}</td>
								<td>{{ list.area }}</td>
								<td>
									<span v-if="list.asset != ''">{{ list.asset }}</span>
									<span v-if="list.asset == ''">-</span>
								</td>
							</tr>
						</table>


					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { dataInJs } from "../../utils/city.js";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
	name: 'index',
	computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			curWebsite: this.$api.getWebsiteType(),
			title: "投资机构",
			notionCode: '', chooseNotionlist: [], fenkd: { children: [] },
			notionlist1: [],
			notionlist2: [],
			notionlist3: [],
			notionlist4: [],
			notionlist5: [],
			notionlist6: [],
			islogin: false,
			userdata: {},
			showscreen: true,
			notiontype: '',
			searchtext: "",
			kwtextsearch: false,
			kwtextsearchtext: "",
			notionbtn: false,
			notionlist: [{ label: "先进制造业", value: "A" }, { label: "传统制造业", value: "B" }, { label: "未来产业", value: "C" }, { label: "省份城市", value: "D" },],
			options: [],
			options1: {},
			options2: {},
			options3: {},
			flag: false,
			cascadervalue: "",
			usernotionlistsave: [],//用户选择的概念列表存储
			usernotionlist: [],//用户选择的概念列表
			page: 1,  //显示的是哪一页
			haspage: true,//是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10,  //最大页数
			provincelist: [],
			provinceid: 0,
			cityid: 0,
			countyid: 0,
			provincedata: [],
			citydata: [],
			countydata: [],
			searchtagdata: [],
			enterpristlist: [],
			usertaglist: [],
			tagcode: '0',
			tyinitialTagdata: [],
			oldcheck: [],
			areadata: dataInJs(),
			tagListdata: {},
			stage: '', //主投阶段 
			type: '',//机构类型
			popular: '', //机构知名度
			stagelist: [{ tagCode: 'A010301', tagName: '种子期' }, { tagCode: 'A010302', tagName: '初创期' }, { tagCode: 'A010303', tagName: '成长期' }, { tagCode: 'A010304', tagName: '成熟期' },],
			typelist: [],
			popularlist: [],
			isShowFreeUserTips: false,
		}
	},
	beforeCreate() {
		this.bus.$emit('loading', true);
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		var _this = this;
		this.userdata = this.getuseriformation();
		// _this.notionlist=NotionTree; 
		this.getocnapidoctaglist();
		//三大产业概念数据
		this.$axios.get(this.$api.tag.notion.list() + '?level=5', { headers: { AuthToken: this.userdata.token } }).then(function (res) {
			// console.log(res.data)
			if (res.data.success) {
				// console.log(res.data.list)
				_this.notionlist = res.data.list;
				_this.options1 = res.data.list[0].children;
				_this.options2 = res.data.list[1].children;
				// _this.options3=res.data.list[2].children;
				_this.flag = true;
				// _this.notionlist=res.data.list;  
			} else {

			}
		}).catch(function (error) {
			// 请求失败处理 console.log(error);
		});
		this.provincedata = this.areadata;
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		var _this = this;
		this.pageHandler(1);
		$('.notionmenu').click(function () {
			// console.log(51411);
			// console.log($(this).siblings('.el-cascader').html())
			$(this).siblings('.el-cascader').click();

		})
		// this.ajaxsearchcompany();
	},
	methods: {
		
		investClick(c_type, tagCode){
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			if(c_type=='stage'){
				this.stage = tagCode;
			}else if(c_type == 'type'){
				this.type = tagCode;
			}else if(c_type == 'popular'){
				this.popular = tagCode;
			}
			this.ajaxsearchcompany();
		},
		//接收子元素传过来的时间
		receive(date) {
			this.finantime = date;
			this.getclue();
		},
		//概念单选 层级显示
		chooseNotion(step, type, data) {
			if (!this.userdata.token) {
				this.isShowFreeUserTips = true;
				return;
			}
			if (type == 'all') {
				this.notionCode = this.chooseNotionlist[step - 2];
				this.chooseNotionlist[step - 1] = '0';
			} else {
				this.chooseNotionlist[step - 1] = data.value;
				for (var i = 0; i < this.chooseNotionlist.length; i++) {
					if (i > step - 1) {
						this.chooseNotionlist[i] = '0';
					}
				}
				this.notionCode = data.value;
			}
			if (data.children != null) {
				if (step == 1) {
					this.notionlist1 = data.children.filter(list => {
						return list.label != '环保';
					});
					// console.log(this.notionlist1)
					this.notionlist2 = []; this.notionlist3 = []; this.notionlist4 = [];
				} else if (step == 2) {
					this.notionlist2 = data.children;
					this.notionlist3 = []; this.notionlist4 = [];
				} else if (step == 3) {
					this.notionlist3 = data.children; this.notionlist4 = [];
				} else if (step == 4) {
					this.notionlist4 = data.children; this.notionlist5 = [];
				} else if (step == 5) {
					this.notionlist5 = data.children;
				}
			}
			console.log(this.notionCode);
			this.ajaxsearchcompany();
		},

		getocnapidoctaglist() {
			var _this = this;
			this.$axios.get(this.$api.tag.tag.list() + '?categoryId=4', { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// console.log(res.data)
				if (res.data.success) {
					// console.log(res.data.list);
					_this.tagListdata = res.data.list;
					var tagdata = res.data.list;
					_this.typelist = tagdata[0].children;
					_this.popularlist = tagdata[3].children.filter(item => {
						return item.tagName != '管理规模大' && item.tagName != '战绩高';
					});
				} else {

				}
			})
			this.$axios.get(this.$api.tag.tag.list() + '?categoryId=1', { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// console.log(res.data)
				if (res.data.success) {
					// console.log('abc',res.data.list); 
					res.data.list.forEach(item => {
						if (item.tagName == '生命周期标签') {
							_this.stagelist = item.children;
						}
					});
					// console.log(zhutoudata[0],zhutoudata[0].children);
					// _this.stagelist = zhutoudata[0].children;
				} else {

				}
			})


		},
		ckll(id) {  //删除已选产业分类标签
			console.log(id);
			var dat = this.usernotionlist, cheked = this.oldcheck;
			console.log(this.usernotionlist);
			for (var i = 0; i < dat.length; i++) {
				if (dat[i].id == id) {
					this.usernotionlist.splice(i, 1);  //删除对应的已选标签 
				}
			}
		},
		emty() { //清空已选概念数据
			this.usernotionlist = [];
			this.usernotionlistsave = [];
			this.ajaxsearchcompany();
			this.$refs['cascaderinput1'].$refs.panel.clearCheckedNodes();  //取消勾选当前选中的所有节点
			this.$refs['cascaderinput2'].$refs.panel.clearCheckedNodes();  //取消勾选当前选中的所有节点
			this.$refs['cascaderinput3'].$refs.panel.clearCheckedNodes();  //取消勾选当前选中的所有节点
		},
		cascaderchange(value) {
			const checkedNodes = this.$refs['cascaderinput'].getCheckedNodes()
			// console.log(checkedNodes) // 获取当前点击的节点
			var ddddg = [];
			for (var i = 0; i < checkedNodes.length; i++) {
				ddddg.push({ name: checkedNodes[i].label, id: checkedNodes[i].value })
			};
			this.usernotionlist = ddddg;
			// console.log(value); 
		},
		//当级联面板打开/关闭时
		cascaderboxtoggle(bool) {
			// if(!bool){
			// 	this.notiontype=0;
			// }
			this.notionbtn = bool;
		},
		//当获取到值时
		cascaderchangesm(checkedns) {
			// console.log('checkedns',checkedns);
			var ddda = [], dddb = [], dddc = [], allddd = [];
			var dddaa = [], dddaa1 = [], dddbb = [], dddbb1 = [], dddcc = [], dddcc1 = [], dddee = [], dddee1 = [], alld = [];
			var ddtds = '';
			for (var i = 0; i < checkedns.length; i++) {
				if (checkedns[i].level == 1) {
					dddaa.push(checkedns[i].value);
					dddaa1.push(checkedns[i].value);
				} else if (checkedns[i].level == 2) {
					dddbb.push(checkedns[i].value);
					dddbb1.push(checkedns[i].value);
				} else if (checkedns[i].level == 3) {
					dddcc.push(checkedns[i].value);
					dddcc1.push(checkedns[i].value);
				} else if (checkedns[i].level == 4) {
					dddee.push(checkedns[i].value);
				}
				allddd.push({ name: checkedns[i].label, id: checkedns[i].value });
			};
			for (var i = 0; i < dddbb.length; i++) {
				let bstring = dddbb[i];
				for (var d = 0; d < dddaa.length; d++) {
					let astring = dddaa[d];
					if (bstring.indexOf(astring) > -1) {
						dddbb[i] = 'xs';
					}
				}
			};
			for (var i = 0; i < dddcc.length; i++) {
				let bstring = dddcc[i];
				for (var d = 0; d < dddbb1.length; d++) {
					let astring = dddbb1[d];
					if (bstring.indexOf(astring) > -1) {
						dddcc[i] = "xs";
					}
				}
			};
			for (var i = 0; i < dddee.length; i++) {
				let bstring = dddee[i];
				for (var d = 0; d < dddcc1.length; d++) {
					let astring = dddcc1[d];
					if (bstring.indexOf(astring) > -1) {
						dddee[i] = "xs";
					}
				}
			};
			for (var i = 0; i < dddbb.length; i++) {
				let bstring = dddbb[i];
				if (bstring != "xs") {
					dddaa.push(bstring);
				}
			};
			for (var i = 0; i < dddcc.length; i++) {
				let bstring = dddcc[i];
				if (bstring != "xs") {
					dddaa.push(bstring);
				}
			};
			for (var i = 0; i < dddee.length; i++) {
				let bstring = dddee[i];
				if (bstring != "xs") {
					dddaa.push(bstring);
				}
			};
			// console.log(dddaa,dddbb,dddcc,dddee);  
			var usernotionlistd = [];
			for (var a = 0; a < dddaa.length; a++) {
				let astring = dddaa[a];
				for (var b = 0; b < allddd.length; b++) {
					if (astring == allddd[b].id) {
						usernotionlistd.push(allddd[b]);
					}
				}
			}
			this.usernotionlistsave = usernotionlistd;
		},
		cascaderchange1(value) {
			// console.log(value);
			const checkedNodes = this.$refs['cascaderinput1'].getCheckedNodes();
			this.oldcheck = checkedNodes;
			this.cascaderchangesm(checkedNodes);
		},
		cascaderchange2(value) {
			const checkedNodes = this.$refs['cascaderinput2'].getCheckedNodes()
			this.cascaderchangesm(checkedNodes);
		},
		cascaderchange3(value) {
			const checkedNodes = this.$refs['cascaderinput3'].getCheckedNodes()
			this.cascaderchangesm(checkedNodes);
		},

		//搜索关键词
		searchkwfun() {
			if (!this.userdata.token) {
				this.isShowFreeUserTips = true;
				this.searchtext='';
				return;
			}
			this.searchtext = $.trim(this.searchtext);
			// if(this.searchtext!="" || ){
			this.ajaxsearchcompany();
			// } 
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		detailrouterto(id) {
			this.routerlinkid('/investement-enterprises', id);
		},
		pageHandler: function (page) {
			this.page = page;
			this.ajaxsearchcompany(page);
		},
		//省份城市选择
		provincechoose(id, i) {
			if (!this.userdata.token) {
				this.isShowFreeUserTips = true;
				return;
			}
			this.provinceid = id; this.cityid = 0; this.countyid = 0;
			this.countydata = [];
			if (i != "all" && this.provincedata[i].children != null) {
				this.citydata = this.provincedata[i].children;
			} else {
				this.citydata = [];
			}
			this.page = 1;
			this.ajaxsearchcompany();
		},
		choosecity(id, i) {
			//	console.log('choosecity',id);
			this.cityid = id; this.countyid = 0;
			if (i != "all" && this.citydata[i].children != null) {
				this.countydata = this.citydata[i].children;
			} else {
				this.countydata = [];
			}
			this.page = 1;
			this.ajaxsearchcompany();
		},
		choosecounty(id) {
			//	console.log('choosecity',id);
			this.countyid = id;
			this.page = 1;
			this.ajaxsearchcompany();
		},
		//删除标签
		deletetag(ind) {
			this.usertaglist = this.usertaglist.filter(function (item, index) {
				return index != ind;
			});
			this.page = 1;
			this.ajaxsearchcompany();
			if (this.usertaglist.length == 0) {
				this.showscreen = true;
			}
		},
		notionbtnfun() {
			this.usernotionlist = this.usernotionlistsave;
			// this.searchtext="";
			this.ajaxsearchcompany();
		},
		//字符串拼接
		jsondouhao(name, data) {
			var notionja = "", douhao = '%2C';
			if (data.length > 0) {
				for (var i = 0; i < data.length; i++) {
					if (i == data.length - 1) {
						douhao = '';
					}
					if (name == 'tag') {
						notionja += data[i] + douhao;
					} else if (name == "notion") {
						notionja += data[i].id + douhao;
					}
				}

				notionja = '&' + name + '=' + notionja;
			}
			return notionja;
		},
		ajaxsearchcompany(pages) {
			this.bus.$emit('loading', true);
			var ajpage = 1;
			if (pages) {
				ajpage = pages;
			}
			this.page = ajpage;
			var _this = this;
			// var searchtagdata1=this.searchtagdata.filter(item=>{return item!='empty'});
			// console.log('searchtagdata1',searchtagdata1);
			// var tagaja=_this.jsondouhao('tag',searchtagdata1);
			// var	notionja=_this.jsondouhao('notion',this.usernotionlistsave);  
			var kwaja = _this.splicing('kw', this.searchtext);;
			var popularja = _this.splicing('popular', this.popular);;
			var typeja = _this.splicing('type', this.type);;
			var stageja = _this.splicing('stage', this.stage);;
			var notionja = this.splicing('notion', this.notionCode);
			var ajaxurl = this.$api.cyl.investorg.list() + '?province=' + this.provinceid + '&city=' + this.cityid + stageja + typeja + kwaja + popularja + '&page=' + ajpage + notionja;
			// console.log(ajaxurl,notionja)
			// if(this.userdata.token == _this.testtoken){
			// 	notionja="";
			// }   
			this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log('企业列表', res.data);
				if (res.data.success) {
					_this.enterpristlist = res.data.list;
					for (var i = 0; i < res.data.list.length; i++) {
						_this.enterpristlist[i].notionlist = _this.taglistfun(_this.enterpristlist[i].notion, _this.enterpristlist[i].notionCode);
						_this.enterpristlist[i].taglist = _this.taglistfun(_this.enterpristlist[i].tag, _this.enterpristlist[i].tagCode);
					}

					_this.bus.$emit('loading', false);
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.haspage = res.data.list.length == res.data.pageSize;
					_this.kwtextsearch = _this.searchtext != "";
					_this.kwtextsearchtext = _this.searchtext;
				} else {

				}
			}).catch(function (error) { });
			// console.log(datas);  
		}
	}
}
</script>

<style></style>
